// import { HttpInterceptorFn } from '@angular/common/http';
// import { inject } from '@angular/core';
// import { Router } from '@angular/router';
// import { catchError, throwError } from 'rxjs';
// import { AppRouters } from '../../constants/app-routers.router';

// export const ApiInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
//   // *********** INJECT ROUTER ***********
//   const router = inject(Router);
//   // *********** LOG REQUEST ***********
//   console.log('request in api interceptor:', req.url);

//   const newReq = req.clone({
//     setHeaders: {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//       Authorization: `Bearer ${localStorage.getItem('token')}`,
//     },
//   });

//   return next(newReq).pipe(
//     //
//     catchError(
//       //
//       (error) => {
//         // *********** CHECK STATUS ***********
//         if ([0].includes(error.status)) {
//           console.log('Error server request: ', error);
//           // *********** NAVIGATE TO ERRORS 404 ***********
//           //TODO: Uncomment this when the errors page is ready
//           // router.navigate([AppRouters.errors_404]);
//           //
//           return throwError(() => 'Error server request');
//         }

//         if ([401, 403].includes(error.status)) {
//           console.log('Unauthorized request: ', error);
//           localStorage.removeItem('token');
//           // navigate to sign in
//           router.navigate([AppRouters.auth_SignIn]);
//           return throwError(() => 'Unauthorized request');
//         }
//         // Safely extract an error message without assuming nested objects exist
//         const safeMessage =
//           (error && typeof error === 'object' && 'error' in error && error.error && error.error.message)
//             ? error.error.message
//             : (error && (error.message || error.statusText || error.stateText)) || 'Unexpected error';

//         console.error('e Error message in INSP: ', safeMessage);
//         console.error('Error message in INSP: ', error);
//         return throwError(() => ({ ...error, message: safeMessage }));
//       },
//     ),
//     //
//   );
// };

import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppRouters } from '../../constants/app-routers.router';
import { RequestDeduplicationService } from '../../services/request-deduplication.service';

export const ApiInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const requestDeduplicationService = inject(RequestDeduplicationService);

  // تحديد نوع body
  const isFormData = req.body instanceof FormData;
  const isBlob = req.body instanceof Blob;

  // Check if this is a file download request (for blob responses)
  const isFileRequest = req.url.includes('/uploads/') || req.url.includes('/download');

  // Check if this is an asset request (images, fonts, CSS, JS, etc.) - exclude from deduplication
  // Only exclude if it's clearly an asset, not an API request
  const isAssetRequest = 
    (!req.url.includes('/api/') && (
      req.url.includes('/assets/') ||
      req.url.endsWith('.css') ||
      req.url.endsWith('.js') ||
      req.url.endsWith('.woff') ||
      req.url.endsWith('.woff2') ||
      req.url.endsWith('.ttf') ||
      req.url.endsWith('.eot') ||
      req.url.endsWith('.svg') ||
      req.url.endsWith('.png') ||
      req.url.endsWith('.jpg') ||
      req.url.endsWith('.jpeg') ||
      req.url.endsWith('.gif') ||
      req.url.endsWith('.ico') ||
      req.url.endsWith('.webp')
    )) ||
    (req.url.startsWith('http') && !req.url.includes('/api/') && (
      req.url.includes('.css') ||
      req.url.includes('.js') ||
      req.url.includes('fonts.googleapis.com') ||
      req.url.includes('fonts.gstatic.com')
    ));

  // Check if this is a public endpoint that doesn't require authentication
  const isPublicEndpoint = 
    req.url.includes('/Email/CreateMail') ||      // Registration
    req.url.includes('/Email/LoginMail') ||       // Login
    req.url.includes('/Email/GenerateOtp') ||     // OTP generation for registration
    req.url.includes('/Email/Otp/LoginMail') ||   // OTP login request
    req.url.includes('/Imail/Otp/Validate');      // OTP validation

  // إعداد headers ذكي
  const headers: { [key: string]: string } = {};
  
  // Only add Authorization header for authenticated endpoints
  if (!isPublicEndpoint) {
    const token = localStorage.getItem('token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  // Only set Accept and Content-Type for non-file requests
  if (!isFormData && !isBlob && !isFileRequest) {
    headers['Content-Type'] = 'application/json';
    headers['Accept'] = 'application/json';
  }

  const newReq = req.clone({ setHeaders: headers });

  // Skip deduplication for asset requests (they are different requests, not duplicates)
  if (isAssetRequest) {
    return next(newReq).pipe(
      catchError((error) => {
        // ======= معالجة أخطاء السيرفر =======
        if ([0].includes(error.status)) {
          console.error('Server request error:', error);
          return throwError(() => new Error('Server request error'));
        }

        // ======= معالجة عدم التفويض =======
        if ([401, 403].includes(error.status)) {
          console.warn('Unauthorized request:', error);
          localStorage.removeItem('token');
          router.navigate([AppRouters.auth_SignIn]);
          return throwError(() => new Error('Unauthorized request'));
        }

        // ======= استخراج رسالة الخطأ بأمان =======
        // ResponseModel يحتوي على Message (بحرف M كبير) أو message (بحرف m صغير)
        let safeMessage = 'حدث خطأ غير متوقع';
        
        if (error && typeof error === 'object' && 'error' in error && error.error) {
          // محاولة استخراج الرسالة من ResponseModel
          if (error.error.Message) {
            safeMessage = error.error.Message;
          } else if (error.error.message) {
            safeMessage = error.error.message;
          } else if (typeof error.error === 'string') {
            safeMessage = error.error;
          } else if (error.error.error) {
            safeMessage = error.error.error;
          }
          
          // التحقق من ErrorCode لرسائل محددة
          const errorCode = error.error.ErrorCode || error.error.errorCode || '';
          if (errorCode === 'USER_NOT_FOUND' || 
              safeMessage.includes('الحساب غير موجود') ||
              safeMessage.includes('ليس لديك حساب') ||
              safeMessage.includes('User not found') ||
              safeMessage.includes('USER_NOT_FOUND')) {
            safeMessage = 'الحساب غير موجود';
          }
        } else if (error && (error.message || error.statusText || error.stateText)) {
          safeMessage = error.message || error.statusText || error.stateText || 'حدث خطأ غير متوقع';
        }

        console.error('Error message in interceptor:', safeMessage, 'Error object:', error);
        return throwError(() => ({ ...error, message: safeMessage }));
      }),
    );
  }

  // Use deduplication service to prevent duplicate API requests
  return requestDeduplicationService.deduplicateRequest(newReq, () => {
    return next(newReq).pipe(
      catchError((error) => {
        // ======= معالجة أخطاء السيرفر =======
        if ([0].includes(error.status)) {
          console.error('Server request error:', error);
          return throwError(() => new Error('Server request error'));
        }

        // ======= معالجة عدم التفويض =======
        if ([401, 403].includes(error.status)) {
          console.warn('Unauthorized request:', error);
          localStorage.removeItem('token');
          router.navigate([AppRouters.auth_SignIn]);
          return throwError(() => new Error('Unauthorized request'));
        }

        // ======= استخراج رسالة الخطأ بأمان =======
        // ResponseModel يحتوي على Message (بحرف M كبير) أو message (بحرف m صغير)
        let safeMessage = 'حدث خطأ غير متوقع';
        
        if (error && typeof error === 'object' && 'error' in error && error.error) {
          // محاولة استخراج الرسالة من ResponseModel
          if (error.error.Message) {
            safeMessage = error.error.Message;
          } else if (error.error.message) {
            safeMessage = error.error.message;
          } else if (typeof error.error === 'string') {
            safeMessage = error.error;
          } else if (error.error.error) {
            safeMessage = error.error.error;
          }
          
          // التحقق من ErrorCode لرسائل محددة
          const errorCode = error.error.ErrorCode || error.error.errorCode || '';
          if (errorCode === 'USER_NOT_FOUND' || 
              safeMessage.includes('الحساب غير موجود') ||
              safeMessage.includes('ليس لديك حساب') ||
              safeMessage.includes('User not found') ||
              safeMessage.includes('USER_NOT_FOUND')) {
            safeMessage = 'الحساب غير موجود';
          }
        } else if (error && (error.message || error.statusText || error.stateText)) {
          safeMessage = error.message || error.statusText || error.stateText || 'حدث خطأ غير متوقع';
        }

        console.error('Error message in interceptor:', safeMessage, 'Error object:', error);
        return throwError(() => ({ ...error, message: safeMessage }));
      }),
    );
  });
};
